var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.98882 0.91255C7.44217 0.365904 6.55442 0.365904 6.00777 0.91255L0.410108 6.51022C0.00777531 6.91255 -0.1103 7.51167 0.108358 8.03645C0.327017 8.56124 0.834306 8.90234 1.40282 8.90234L12.5981 8.89797C13.1623 8.89797 13.674 8.55686 13.8926 8.03208C14.1113 7.5073 13.9888 6.90818 13.5909 6.50584L7.9932 0.908177L7.98882 0.91255Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretUp);
export default __webpack_public_path__ + "static/media/caret-up.296543275399e08ca154cdf51796d351.svg";
export { ForwardRef as ReactComponent };